import type { ScheduleTranslation } from './schedule.en'

export const scheduleTeIn: ScheduleTranslation = {
  common: {
    after: `తర్వాత`,
    cancel: `రద్దు`,
    clear: `తొలగించు`,
    closed: `మూసివేసింది`,
    create: `సృష్టించు`,
    daily: `ప్రతిరోజూ`,
    delete: `తొలగించు`,
    deleteError: {
      inUseGeneric: `ఈ షెడ్యూల్ స్విచ్‌బోర్డ్‌లో ఉపయోగంలో ఉన్నందున తొలగించలేరు. స్విచ్‌బోర్డ్ నుండి తీసివేసి మళ్లీ ప్రయత్నించండి.`,
      inUseMultiple: `ఈ షెడ్యూల్ ఈ స్విచ్‌బోర్డ్‌లలో ఉపయోగంలో ఉన్నందున తొలగించలేరు: {{switchboardNames}}. ఆ స్విచ్‌బోర్డ్‌ల నుండి తీసివేసి మళ్లీ ప్రయత్నించండి.`,
      inUseSingle: `ఈ షెడ్యూల్ ఈ స్విచ్‌బోర్డ్‌లో ఉపయోగంలో ఉన్నందున తొలగించలేరు: {{switchboardNames}}. ఆ స్విచ్‌బోర్డ్ నుండి తీసివేసి మళ్లీ ప్రయత్నించండి.`,
      listWithMore: `{{visibleNames}}, ఇంకా {{remaining}}`,
    },
    description: `వివరణ`,
    edit: `సవరించు`,
    from: `నుండి`,
    holiday: `సెలవు`,
    monthly: `నెలవారీ`,
    name: `పేరు`,
    never: `ఎప్పుడూ కాదు`,
    onDate: `తేదీకి`,
    routing: `రూటింగ్`,
    save: `సేవ్ చేయి`,
    saving: `సేవ్ అవుతోంది...`,
    timeZone: `సమయ మండలం`,
    to: `వరకు`,
    validationErrorTitle: `ధృవీకరణ లోపం`,
    weekdayShort: {
      fri: `శుక్ర`,
      mon: `సోమ`,
      sat: `శని`,
      sun: `ఆది`,
      thu: `గురు`,
      tue: `మంగళ`,
      wed: `బుధ`,
    },
    weekdayLong: {
      fri: `శుక్రవారం`,
      mon: `సోమవారం`,
      sat: `శనివారం`,
      sun: `ఆదివారం`,
      thu: `గురువారం`,
      tue: `మంగళవారం`,
      wed: `బుధవారం`,
    },
    weekly: `వారానికి`,
    yearly: `ఏడాదికి`,
  },
  detail: {
    actions: {
      deleteScheduleModalTitle: `షెడ్యూల్ తొలగించు`,
      deleteScheduleTitle: `షెడ్యూల్ తొలగించు`,
      editScheduleTitle: `షెడ్యూల్ సవరించు`,
    },
    currentRouting: `ప్రస్తుత రూటింగ్:`,
    error: `లోపం`,
    header: {
      breadcrumbCurrent: `షెడ్యూళ్లను సవరించు`,
      breadcrumbRoot: `షెడ్యూళ్లు`,
    },
    hoursView: {
      calendar: `క్యాలెండర్`,
      list: `జాబితా`,
    },
    loading: `షెడ్యూల్ లోడ్ అవుతోంది...`,
    notFound: {
      description: `మీరు వెతుకుతున్న షెడ్యూల్ లేదు.`,
      title: `షెడ్యూల్ కనిపించలేదు`,
    },
    toast: {
      createOverrideFailedTitle: `ఓవర్‌రైడ్ సృష్టించడంలో విఫలమైంది`,
      createWeeklyHoursFailedTitle: `వారపు గంటలు సృష్టించడంలో విఫలమైంది`,
      deleteEventFailedTitle: `ఈవెంట్ తొలగించడంలో విఫలమైంది`,
      deleteScheduleFailedTitle: `షెడ్యూల్ తొలగించడంలో విఫలమైంది`,
      eventDeleted: `ఈవెంట్ విజయవంతంగా తొలగించబడింది`,
      eventsUpdatedDescription: `{{count}} ఈవెంట్‌లకు సమయ మండలం నవీకరించబడింది`,
      eventsUpdatedTitle: `ఈవెంట్‌లు నవీకరించబడ్డాయి`,
      failedTitle: `విఫలమైంది`,
      genericError: `లోపం జరిగింది`,
      holidaysAddFailed: `{{count}} సెలవులు జోడించడంలో విఫలమైంది`,
      holidaysAddedSuccess: `{{count}} సెలవులు విజయవంతంగా జోడించబడ్డాయి`,
      holidaysAddedWithFailures: `{{successCount}} సెలవులు విజయవంతంగా జోడించబడ్డాయి ({{errorCount}} విఫలమయ్యాయి)`,
      loadEventsFailedDescription: `ఈవెంట్‌లు లోడ్ చేయడంలో లోపం వచ్చింది`,
      loadEventsFailedTitle: `షెడ్యూల్ ఈవెంట్‌లను లోడ్ చేయడంలో విఫలమైంది`,
      loadScheduleFailedDescription: `షెడ్యూల్ లోడ్ చేయడంలో లోపం వచ్చింది`,
      loadScheduleFailedTitle: `షెడ్యూల్ లోడ్ చేయడంలో విఫలమైంది`,
      overrideCreated: `ఓవర్‌రైడ్ విజయవంతంగా సృష్టించబడింది`,
      overrideUpdated: `ఓవర్‌రైడ్ విజయవంతంగా నవీకరించబడింది`,
      scheduleDeleted: `షెడ్యూల్ విజయవంతంగా తొలగించబడింది`,
      scheduleUpdated: `షెడ్యూల్ విజయవంతంగా నవీకరించబడింది`,
      successTitle: `విజయం`,
      updateOverrideFailedTitle: `ఓవర్‌రైడ్ నవీకరించడంలో విఫలమైంది`,
      updateScheduleFailedTitle: `షెడ్యూల్ నవీకరించడంలో విఫలమైంది`,
      updateWeeklyHoursFailedTitle: `వారపు గంటలు నవీకరించడంలో విఫలమైంది`,
      weeklyHoursCreated: `వారపు గంటలు విజయవంతంగా సృష్టించబడ్డాయి`,
      weeklyHoursUpdated: `వారపు గంటలు విజయవంతంగా నవీకరించబడ్డాయి`,
    },
  },
  holidays: {
    actions: {
      addWithCount: `సెలవులు జోడించు ({{count}})`,
    },
    common: {
      unknown: `తెలియదు`,
    },
    customPrompt: {
      link: `మీ స్వంత ప్రత్యేక సమయాలను సెటప్ చేయండి`,
      prefix: `మీరు వెతుకుతున్న సెలవు కనిపించలేదా?`,
    },
    empty: `ఏ ప్రీసెట్ సెలవులు అందుబాటులో లేవు`,
    error: {
      failedToLoad: `సెలవులను లోడ్ చేయడంలో విఫలమైంది`,
    },
    loading: `సెలవులు లోడ్ అవుతున్నాయి...`,
    modal: {
      description: `మీ ఓవర్‌రైడ్ జాబితాలో జోడించాలనుకునే సెలవు ప్రీసెట్‌లను ఎంచుకోండి. ఈవెంట్ సృష్టించిన తర్వాత ప్రతి సెలవు గంటలను సవరించవచ్చు.`,
      title: `ప్రీసెట్ సెలవులు జోడించు`,
    },
    submitting: `మీ షెడ్యూల్ నవీకరించబడుతోంది, ఇది కేవలం కొన్ని క్షణాలు పడుతుంది.`,
    table: {
      holiday: `సెలవు`,
      nextOccurrence: `తదుపరి సంభవం`,
    },
    validation: {
      noneSelectedDescription: `జోడించడానికి కనీసం ఒక సెలవును ఎంచుకోండి`,
      noneSelectedTitle: `ఎలాంటి సెలవులు ఎంచుకోలేదు`,
    },
  },
  list: {
    card: {
      lastUpdated: `చివరిసారి నవీకరించబడింది`,
    },
    common: {
      notAvailable: `అందుబాటులో లేదు`,
    },
    delete: `తొలగించు`,
    deleteTitle: `షెడ్యూల్ తొలగించు`,
    empty: `షెడ్యూళ్లు కనబడలేదు`,
    grid: {
      errorTitle: `లోపం`,
    },
    hoursVary: `గంటలు మారుతాయి`,
    loading: `షెడ్యూళ్లు లోడ్ అవుతున్నాయి...`,
    newSchedule: `కొత్త షెడ్యూల్`,
    noPermission: `షెడ్యూళ్లను యాక్సెస్ చేయడానికి మీకు అనుమతి లేదు.`,
    noSchedules: `షెడ్యూళ్లు కనబడలేదు`,
    noSchedulesDescription: `మీ అందుబాటును జోడించడానికి కొత్త షెడ్యూల్ జోడించండి`,
    pagination: {
      all: `అన్నీ`,
      jumpToPage: `పేజీ {{page}}కి వెళ్ళు`,
      nextPage: `తదుపరి పేజీ`,
      previousPage: `మునుపటి పేజీ`,
      resultsPerPage: `ప్రతి పేజీకి ఫలితాలు:`,
    },
    status: {
      closed: `మూసివేసింది`,
      holiday: `సెలవు`,
      openNow: `ఇప్పుడు తెరిచి ఉంది`,
    },
    subtitle: `షెడ్యూల్ కాన్ఫిగరేషన్‌లను చూడండి మరియు నిర్వహించండి`,
    title: `షెడ్యూళ్లు`,
    toast: {
      createFailed: `సృష్టించడం విఫలమైంది`,
      createFailedDescription: `షెడ్యూల్ సృష్టించడంలో విఫలమైంది`,
      createSuccess: `షెడ్యూల్ సృష్టించబడింది`,
      createSuccessDescription: `షెడ్యూల్ విజయవంతంగా సృష్టించబడింది.`,
      deleteFailed: `తొలగించడం విఫలమైంది`,
      deleteFailedDescription: `షెడ్యూల్ తొలగించడంలో విఫలమైంది`,
      deleteSuccess: `షెడ్యూల్ తొలగించబడింది`,
      deleteSuccessDescription: `షెడ్యూల్ విజయవంతంగా తొలగించబడింది.`,
    },
    unavailable: `అందుబాటులో లేదు`,
  },
  modal: {
    create: {
      cancel: `రద్దు`,
      defaultWeeklyHoursLabel: `డిఫాల్ట్ వారపు గంటలను చేర్చు`,
      descriptionLabel: `వివరణ`,
      descriptionPlaceholder: `ఈ షెడ్యూల్ కోసం ఐచ్ఛిక వివరణ`,
      nameLabel: `పేరు`,
      namePlaceholder: `బిజినెస్ అవర్స్`,
      saveSchedule: `షెడ్యూల్ సేవ్ చేయి`,
      saving: `సేవ్ అవుతోంది...`,
      timeZoneLabel: `సమయ మండలం`,
      title: `కొత్త షెడ్యూల్`,
      validationNameRequired: `దయచేసి షెడ్యూల్‌కు పేరు నమోదు చేయండి`,
      validationTitle: `ధృవీకరణ`,
    },
    deleteConfirmation: {
      cancel: `రద్దు`,
      confirm: `తొలగించు`,
      defaultBodyWithItemPrefix: `మీరు `,
      defaultBodyWithItemSuffix: `ను ఖచ్చితంగా తొలగించాలనుకుంటున్నారా? ఈ చర్యను వెనక్కి తిప్పలేరు.`,
      defaultBodyWithoutItem: `ఈ అంశాన్ని ఖచ్చితంగా తొలగించాలనుకుంటున్నారా? ఈ చర్యను వెనక్కి తిప్పలేరు.`,
      defaultTitle: `అంశం తొలగించు`,
    },
    editSchedule: {
      applyTimezoneChanges: `సమయ మండల మార్పులను వర్తింపజేయండి:`,
      customEventsHelp: `ఉన్న కస్టమ్ ఈవెంట్‌లకు సమయ మండలాన్ని అప్డేట్ చేయకూడదనుకుంటే ఈ ఎంపికను అన్‌చెక్ చేయండి.`,
      customEventsWithCount: `కస్టమ్ ఈవెంట్‌లు ({{count}})`,
      descriptionPlaceholder: `ఈ షెడ్యూల్ కోసం ఐచ్ఛిక వివరణ`,
      namePlaceholder: `బిజినెస్ అవర్స్`,
      timezoneWarning: `ఇది మీ వారపు గంటలను ఎంచుకున్న సమయ మండలానికి నవీకరిస్తుంది.`,
      title: `షెడ్యూల్ సవరించు`,
      updateSchedule: `షెడ్యూల్ నవీకరించు`,
      validation: {
        nameRequired: `దయచేసి షెడ్యూల్‌కు పేరు నమోదు చేయండి`,
      },
    },
    override: {
      dateTime: `తేదీ & సమయం`,
      dateType: {
        multipleDays: `బహుళ రోజులు`,
        singleDay: `ఒక రోజు`,
      },
      endRepeat: `పునరావృత ముగింపు`,
      irregularRepeat: `ఈ ఓవర్‌రైడ్‌లో అసమాన పునరావృత నమూనాలు ఉన్నాయి మరియు సవరించలేరు`,
      irregularRepeatNamed: `{{name}}లో సవరించలేని పునరావృత నమూనా ఉంది.`,
      irregularRepeatNextOccurrence: `తదుపరి సంఘటన {{occurrence}}`,
      holidayTemplateCheckPending: `{{name}} పునరావృత నమూనాను తనిఖీ చేస్తున్నాం. తేదీ మరియు పునరావృత నియంత్రణలు తాత్కాలికంగా అందుబాటులో లేవు.`,
      holidayTemplateCheckUnavailable: `{{name}} పునరావృత నమూనాను ధృవీకరించలేకపోయాం. తేదీ మరియు పునరావృత నియంత్రణలు అందుబాటులో లేవు.`,
      loadingDetails: `ఓవర్‌రైడ్ వివరాలు లోడ్ అవుతున్నాయి...`,
      monthly: {
        nthWeekday: `{{nth}}{{suffix}} {{weekday}}`,
        specificDate: `{{day}}{{suffix}}`,
      },
      namePlaceholder: `ఓవర్‌రైడ్ పేరు`,
      startTimeAriaLabel: `ప్రారంభ సమయం`,
      startDateAriaLabel: `ప్రారంభ తేదీ`,
      endDateAriaLabel: `ముగింపు తేదీ`,
      endRepeatDateAriaLabel: `పునరావృత ముగింపు తేదీ`,
      endTimeAriaLabel: `ముగింపు సమయం`,
      timePlaceholder: `h:mm`,
      meridiemAriaLabel: `{{label}} పూర్వాహ్నం/అపరాహ్నం`,
      meridiemOptionsAriaLabel: `{{label}} పూర్వాహ్నం/అపరాహ్నం ఎంపికలు`,
      timeOptionsAriaLabel: `{{label}} ఎంపికలు`,
      occurrences: `సార్లు`,
      repeat: `పునరావృతం`,
      repeatEvery: `ప్రతి`,
      repeatOn: `ఈ రోజున పునరావృతం`,
      repeatUnit: {
        days: `రోజు(లు)`,
        months: `నెల(లు)`,
        weeks: `వారం(లు)`,
        years: `సంవత్సరం(లు)`,
      },
      timeType: {
        closedAllDay: `రోజంతా మూసివేసి ఉంది`,
        setClosedHours: `మూసే గంటలు సెట్ చేయండి`,
      },
      titleCreate: `ఓవర్‌రైడ్ జోడించు`,
      titleEdit: `షెడ్యూల్ ఓవర్‌రైడ్ సవరించు`,
      validation: {
        endAfterStart: `ముగింపు తేదీ/సమయం ప్రారంభం తర్వాత ఉండాలి`,
        endDateRequired: `బహుళ రోజుల ఈవెంట్‌లకు ముగింపు తేదీని ఎంచుకోండి`,
        endDateRequiredShort: `దయచేసి ముగింపు తేదీని ఎంచుకోండి`,
        invalidDateTime: `దయచేసి సరైన తేదీ మరియు సమయ విలువలను ఇవ్వండి`,
        monthRequired: `వార్షిక పునరావృతం కోసం నెలను ఎంచుకోండి`,
        monthlyPatternRequired: `నెలవారీ పునరావృత నమూనాను ఎంచుకోండి`,
        nameRequired: `ఓవర్‌రైడ్‌కు పేరు నమోదు చేయండి`,
        occurrencesRequired: `దయచేసి పునరావృతాల సంఖ్యను నమోదు చేయండి`,
        startEndTimeRequired: `ప్రారంభ మరియు ముగింపు సమయాలను ఎంచుకోండి`,
        validDayRequired: `సరైన రోజును ఎంచుకోండి (1-31)`,
        validWeekdayPatternRequired: `సరైన వారపు రోజు నమూనాను ఎంచుకోండి`,
        weekdayRequired: `కనీసం ఒక వారపు రోజును ఎంచుకోండి`,
      },
      yearly: {
        nthWeekday: `{{month}}లోని {{nth}}{{suffix}} {{weekday}}`,
        specificDate: `{{month}}లోని {{day}}{{suffix}}`,
      },
    },
  },
  overrides: {
    actions: {
      addHoliday: `సెలవు జోడించు`,
      addOverride: `ఓవర్‌రైడ్ జోడించు`,
    },
    empty: `షెడ్యూల్ ఓవర్‌రైడ్‌లు ఏవీ కాన్ఫిగర్ చేయలేదు`,
    item: {
      deleteHolidayTitle: `సెలవు తొలగించు`,
      deleteOverrideModalTitle: `ఓవర్‌రైడ్ తొలగించు`,
      deleteOverrideTitle: `ఓవర్‌రైడ్ తొలగించు`,
      editOverrideTitle: `ఓవర్‌రైడ్ సవరించు`,
      overrideInEffect: `ఓవర్‌రైడ్ అమల్లో ఉంది`,
      repeatsPrefix: `పునరావృతం`,
    },
    title: `షెడ్యూల్ ఓవర్‌రైడ్‌లు`,
  },
  status: {
    closed: `మూసివేసింది`,
    holiday: `సెలవు`,
    open: `తెరిచి ఉంది`,
  },
  weeklyHours: {
    calendar: {
      confirmCreateDescription: `ఎంచుకున్న ఈ సమయ పరిధికి కొత్త షెడ్యూల్ ఎంట్రీ సృష్టించాలా?`,
      confirmCreateTitle: `షెడ్యూల్ ఎంట్రీ సృష్టించు`,
      confirmDeleteTitle: `సమయ స్లాట్ తొలగించు`,
      deleteEventLabel: `{{day}} {{time}} తొలగించు`,
    },
    table: {
      confirmDeleteDayDescription: `మీరు {{day}}కి చెందిన అన్ని సమయ స్లాట్‌లను తొలగించాలనుకుంటున్నారా? ఈ చర్యను వెనక్కి తిప్పలేరు.`,
      confirmDeleteDayItem: `{{day}} వారపు గంటలు`,
      confirmDeleteDayTitle: `సమయ స్లాట్ తొలగించు`,
      confirmDeleteSlotItem: `{{day}} సమయ స్లాట్`,
      confirmDeleteSlotTitle: `సమయ స్లాట్ తొలగించు`,
      days: {
        friday: `శుక్రవారాలు`,
        monday: `సోమవారాలు`,
        saturday: `శనివారాలు`,
        sunday: `ఆదివారాలు`,
        thursday: `గురువారాలు`,
        tuesday: `మంగళవారాలు`,
        wednesday: `బుధవారాలు`,
      },
      slot: {
        addTitle: `షెడ్యూల్ ఎంట్రీ జోడించు`,
        addDayLabel: `{{day}} సమయాలను జోడించు`,
        deleteTitle: `షెడ్యూల్ ఎంట్రీ తొలగించు`,
        deleteSlotLabel: `{{day}} {{start}} నుండి {{end}} వరకు సమయాలను తొలగించు`,
        endPlaceholder: `ముగింపు`,
        startPlaceholder: `ప్రారంభం`,
        startTimeLabel: `{{day}} ప్రారంభ సమయం`,
        startTimeLabelNumbered: `{{day}} ప్రారంభ సమయం, ఎంట్రీ {{number}}`,
        endTimeLabel: `{{day}} ముగింపు సమయం`,
        endTimeLabelNumbered: `{{day}} ముగింపు సమయం, ఎంట్రీ {{number}}`,
        unavailable: `అందుబాటులో లేదు`,
      },
      toggle: {
        disableDay: `{{day}} నిలిపివేయి`,
        enableDay: `{{day}} ప్రారంభించు`,
      },
    },
    timeSelect: {
      noTimesFound: `సమయాలు కనబడలేదు`,
    },
  },

  queryError: {
    fetchSchedules: `Failed to fetch schedules`,
    fetchSchedule: `Failed to fetch schedule`,
    fetchEvents: `Failed to fetch schedule events`,
    fetchHolidays: `Failed to fetch schedule holidays`,
    createSchedule: `Failed to create schedule`,
    updateSchedule: `Failed to update schedule`,
    createEvent: `Failed to create schedule event`,
    updateEvent: `Failed to update schedule event`,
    deleteEvent: `Failed to delete schedule event`,
    generic: `ఏదో తప్పు జరిగింది. దయచేసి మళ్లీ ప్రయత్నించండి.`,
  },
}
